import { Box, Flex, FlexProps } from "@chakra-ui/react"
import { merge } from "lodash"
import React, { forwardRef } from "react"

type Props = {
  nestedBorderColorOverride?: string
}

export const Block = forwardRef<HTMLDivElement, React.PropsWithChildren<Props>>(
  ({ children, nestedBorderColorOverride }, ref) => {
    const borderColor = nestedBorderColorOverride ?? "ds.border.default"
    return (
      <Box
        ref={ref}
        p={6}
        bg="ds.surface.raised.resting"
        shadow="ds.raised"
        borderRadius="20px"
        data-ui="layout-block"
        sx={{
          // Remove the shadow and apply a border when a Block
          // is nested inside another Block
          "[data-ui='layout-block'] &": {
            border: "1px solid",
            borderColor: borderColor,
            shadow: "none",
          },
        }}
      >
        {children}
      </Box>
    )
  }
)

export const Blocks = forwardRef<HTMLDivElement, FlexProps>(
  ({ children, sx = {}, ...props }, ref) => {
    return (
      <Flex
        ref={ref}
        data-ui="layout-blocks"
        flexDirection="column"
        sx={merge(
          {
            gap: "var(--layout-area-spacing-gap)",
            '[data-ui="layout-blocks"] &': {
              gap: 4,
            },
          },
          sx
        )}
        {...props}
      >
        {children}
      </Flex>
    )
  }
)
